import onboardingSlide1Src from '../assets/images/cs-home/cs-pic1-slider.png';
import onboardingSlide2Src from '../assets/images/cs-home/cs-pic2-slider.png';
import onboardingSlide3Src from '../assets/images/cs-home/cs-pic3-slider.png';

const CS_HOME_FAQ_LIST = [
    {
        id: 12,
        question: 'I got only common cards, why?',
        answer: 'Currently, only common cards are available in the game. As the game grows, cards of different rarity will be introduced.'
    },
    {
        id: 13,
        question: 'What is the benefit of playing common cards?',
        answer: 'Common cards can help managers master the mechanics of the game and improve their skills. A strong common card collection will give you an advantage in future.'
    },
    {
        id: 14,
        question: 'Will common cards be valuable in future?',
        answer: 'While common cards may not have the same power as other cards in future, they can still be useful in certain situations and in beginner’s level tournaments.'
    },
    {
        id: 15,
        question: 'I don’t have any playing cards for the round, or I don’t have enough cards. What should I do?',
        answer: 'If you are missing playing cards, you can use cards that are not participating in the competition but can be used as fillers. These cards won’t earn you points in the round, but they’ll allow you to create a lineup and participate. Only the playing cards in your lineup will earn you points.'
    },
    {
        id: 16,
        question: 'What is the benefit of joining Powerplay now?',
        answer: 'By joining Powerplay now, you get to experience the game before it becomes available for everyone. Playing at the early stages of Powerplay can help you win more cards, build stronger card collections, improve your game experience, and help the game develop in the right direction.'
    },
    {
        id: 17,
        question: 'What advantages come with being an early Powerplay adopter?',
        answer: 'As an early adopter, you can provide valuable feedback to the developers and help shape the game’s future. Powerplay unites esports fans from all over the world, which can be a great way to make new friends and build a unique community.'
    },
    {
        id: 18,
        question: 'Can I exchange duplicate cards?',
        answer: 'Yes, you can exchange your duplicate cards at Powerplay Marketplace Сard Exchange.'
    },
    {
        id: 4,
        question: 'What is the player score?',
        answer: 'The player score is the points a player receives for their performance in a real match.'
    },
    {
        id: 1,
        question: 'What is a fantasy game?',
        answer: "Users set up their virtual team (five players) with the collected cards. Subsequently, the team receives points according to the actual performance of the players in a real match. A player's performance in the match thus has a direct impact on the virtual world of Powerplay tournaments."
    },
    {
        id: 2,
        question: 'What is the difference between Powerplay and other fantasy games?',
        answer: 'Powerplay is a card fantasy game, which means you need to collect cards to participate. Also, we are focused on esports as an industry.'
    },
    {
        id: 19,
        question: 'Is Manager and Player the same thing at Powerplay?',
        answer: 'No. Manager is a user of Powerplay platform. Player is a real-life esports athlete.'
    },
    {
        id: 11,
        question: 'What in-game rewards can I expect at Powerplay?',
        answer: 'Card bundles at the start. Later we plan to launch additional in-game rewards, including Counter-Strike game assets.'
    },
    {
        id: 8,
        question: 'Is Powerplay a free-to-play game?',
        answer: 'Yes, it is a free-to-play game. There are no prerequisites in the basic game.'
    },
    {
        id: 6,
        question: 'What are the prices at Powerplay?',
        answer: "Currently, Powerplay's platform is available to all fantasy sports fans free of charge. There are no fees or costs associated with participating in the game."
    },
    {
        id: 3,
        question: 'Can I play one card in different tournaments at the same time?',
        answer: 'No, each card can be used only in one active roster.'
    },
    {
        id: 7,
        question: 'How can I collect more cards?',
        answer: 'As of now, you can collect more cards by participating in and winning tournaments.'
    },
    {
        id: 20,
        question: 'Can I play in different tournaments at the same time?',
        answer: 'Yes, if you have enough cards.'
    },
    {
        id: 21,
        question: 'If I missed previous rounds, can I still join the tournament?',
        answer: 'Absolutely! You can enter any upcoming round, provided you create your lineup before the round begins. You will receive points for the rounds your team played in.'
    },
    {
        id: 22,
        question: 'Can I use the same player cards in different roles?',
        answer: 'Yes.'
    },
    {
        id: 23,
        question: 'What if a player in my roster is unable to participate in the selected round?',
        answer: 'In this case, the player will not earn any points for that round.'
    },
    {
        id: 24,
        question: 'Is it possible to receive negative points from the card?',
        answer: "Yes. The most common reason is terrible stats on players' deaths not compensated by positive input stats."
    },
    {
        id: 25,
        question: "What if the player's card I'd like to use is absent in the game?",
        answer: "Some cards won't be added to the game immediately; however, please remember that other managers have the same conditions. This won't apply to the situation when an card is just absent from your inventory."
    }
];

const ONBOARDING_LIST = [
    {
        id: 1,
        index: 1,
        name: 'Select a tournament',
        label: 'Choose an upcoming match that you want to compete in.',
        description: 'Powerplay hosts competitions corresponding to the largest international CS tournaments',
        imageUrl: onboardingSlide1Src,
        nextStep: {
            index: 2,
            description: 'Powerplay provides real-time player analytics and data designed to assist managers at all levels in making decisions',
            imageUrl: onboardingSlide2Src
        }
    },
    {
        id: 2,
        index: 2,
        name: 'Build a lineup',
        label: 'Use your knowledge of Counter-Strike 2 and general manager strategies to select the best players for your team.',
        description: 'Powerplay provides real-time player analytics and data designed to assist managers at all levels in making decisions',
        imageUrl: onboardingSlide2Src,
        nextStep: {
            index: 3,
            description: 'Compete for in-game rewards with other fans around the world. Step into the exciting realm of fantasy sports with Powerplay!',
            imageUrl: onboardingSlide3Src
        }
    },
    {
        id: 3,
        index: 3,
        name: 'Join a competition',
        label: 'Score points based on the real-life performance of the players in your lineup.',
        description: 'Compete for in-game rewards with other fans around the world. Step into the exciting realm of fantasy sports with Powerplay!',
        imageUrl: onboardingSlide3Src,
        nextStep: {
            index: 1,
            description: 'Powerplay hosts competitions corresponding to the largest international CS tournaments',
            imageUrl: onboardingSlide1Src
        }
    }
];

export {
    CS_HOME_FAQ_LIST,
    ONBOARDING_LIST
}
